import { useCompetencyUrl } from '../competencyRouting';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const CompetencyMenu = () => {
  const { getSingleEntityUrl } = useCompetencyUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} />
    </SidebarStickyMenu>
  );
};

export default CompetencyMenu;
